import React from 'react'
import {  Link } from 'react-router-dom'

// /import { withRouter } from 'react-router-dom'
import area from '../../images/area.svg'
import dashboard from '../../images/dashboard.svg'
import horizontalBar from '../../images/horizontal-bar.svg'
import map from '../../images/map.svg'
import verticalBar from '../../images/vertical-bar.svg'

class RecentlyViewd extends React.Component {
  render () {
    return (
      <div className='home'>
        <div className='render-body'>
          <div className='iframe-container'>
            <div className='row pXSm-45'>
              <div className='col-sm-12'>
                <h2 className='fontSm-22 ScalaSansOT-Bold mYSm-22'>Recently Viewed Reports</h2>
              </div>
              <div className='col-sm-12'>
                <div className='row'>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={dashboard} className='' alt='dashboard' /></div>
                          Applicant Gender Distribution by Race & Ethnicity
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={area} className='' alt='area' /></div>
                          Submitted Applicants by Month - Discrete Totals
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={verticalBar} className='' alt='verticalBar' /></div>
                          Submitted Applicants by Month, Cohort - Discrete Totals
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={map} className='' alt='map' /></div>
                          Applicants by State of Residency
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={horizontalBar} className='' alt='dashboard' /></div>
                          Section Completion Status
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={verticalBar} className='' alt='area' /></div>
                          Submitted Applicants by Week - Running Totals
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={verticalBar} className='' alt='verticalBar' /></div>
                          Submitted Applicants by Month - Running Totals
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='col-sm-4 col-xl-3'>
                    <div className=''>
                      <div className='line-height-18 sub-menu pXSm-15 card-custom'>
                        <Link to='/Reports' label='Reports' onClick={(e) => this.toggleSubMenu(e, 6, false)}>
                          <div className='sub-menu-icon mBottom-20'><img src={map} className='' alt='map' /></div>
                          Non US Applicants by Country of Citizenship
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

// /export default withRouter(RecentlyViewd)
export default RecentlyViewd
